module.exports = __webpack_public_path__ + "static/media/plus.2feb83c6.svg";